"use strict";
'use es6'; // Adapts the array of merchandise into an object

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.merchandiseAdapterV2 = exports.default = void 0;

var merchandiseAdapter = function merchandiseAdapter(merchandise) {
  var merchandiseMap = {};
  merchandise.forEach(function (merchandiseItem) {
    // Endpoint returns edition in all caps, but FE apps use lower case edition to refer to strings and other constants
    if (merchandiseItem.edition) {
      merchandiseItem.edition = merchandiseItem.edition.toLowerCase();
    }

    merchandiseMap[merchandiseItem.id] = merchandiseItem;
  });
  return merchandiseMap;
};

exports.merchandiseAdapterV2 = exports.default = merchandiseAdapter;